import { defineStore } from 'pinia';
import { ref } from 'vue';
import { navigationItems } from '@/js/consts/navigation';

export const useNavigationStore = defineStore(
    'navigation',
    () => {
        const items = ref(navigationItems);
        const visible = ref(false);
        const settings_visible = ref(false);
        const support_visible = ref(false);

        const toggle = () => {
            visible.value = !visible.value;
        };

        const hide = () => {
            visible.value = false;
        };

        const show = () => {
            visible.value = true;
        };

        return {
            items,
            visible,
            settings_visible,
            support_visible,
            toggle,
            hide,
            show,
        };
    },
    {
        persist: {
            storage: sessionStorage,
            pick: ['visible'],
        },
    }
);
